import {ActionEnum} from "../action.enum";
import {ChecklistEntry} from "../../models/checklist/checklist-entry-model";
import {ChecklistFillOutFilter} from "../../enums/checklist/checklist-fill-out-filter.enum";
import { JobAccordions } from './checklist-fill-out.enum';

export namespace ChecklistFillOutAction {

  export class InitFillOut {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_INIT_FILL_OUT;
    constructor (public jobId: string, public checklistId: string, public checklistRevisionId: string) {}
  }

  export class InitPreview {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_INIT_PREVIEW;
    constructor(
      public checklistTemplateId: string,
      public checklistTemplateVersionId: string,
      public jobId: string,
      public jobRoutineId: string,
      public jobRoutineTemplateModuleVersionId: string,
    ) {}
  }

  export class SetEntryValue {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_SET_ENTRY_VALUE;
    constructor (public checklistEntryId: string, public values: Partial<ChecklistEntry>) {}
  }

  export class MoveBackward {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_MOVE_BACKWARD;
  }

  export class MoveForward {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_MOVE_FORWARD;
  }

  export class ResetState {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_RESET_STATE;
  }

  export class SaveCurrentState {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_SAVE_STATE;
  }

  export class AutoSave {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_AUTO_SAVE;
  }

  export class CanEvaluateAssessment {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_CAN_EVALUATE_ASSESSMENT;
  }

  export class SignChecklist {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_SIGN;

    constructor(
      public signature: string,
      public personalNumber: string,
      public assessmentTypeId: string,
      public setJobToDone: boolean,
      public assessmentIsRequired: boolean,
    ) {}
  }

  export class PrintChecklist {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_PRINT;
  }

  export class SaveAndPrintChecklist {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_SAVE_AND_PRINT;
  }

  export class ApplyFilter {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_APPLY_FILTER;

    constructor(public filter: ChecklistFillOutFilter) {}
  }

  export class ClearFilter {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_CLEAR_FILTER;
  }

  export class ToggleNotFilledAndNegativeFilter {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_TOGGLE_ONLY_NOT_FILLED_AND_NEGATIVE_FILTER;
  }

  export class ToggleDescriptionsVisibility {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_TOGGLE_DESCRIPTIONS_VISIBILITY;
  }

  export class ToggleImagesVisibility {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_TOGGLE_IMAGES_VISIBILITY;
  }

  export namespace Job {

    export class ReFetchJob {
      static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_FETCH_JOB;
    }

    export class JobStartedDueToAutosave {
      static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_JOB_STARTED_DUE_TO_AUTOSAVE;
      constructor(public jobId: string) {}
    }

    export class OpenChatAccordionForChecklistEntry {
      static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_ADD_CHAT_FOR_ENTRY;

      constructor(public checklistEntry: ChecklistEntry) {

      }
    }

    export class ClearChecklistEntryForChat {
      static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_CLEAR_CHECKLIST_ENTRY_FOR_CHAT;
    }

    export class ReloadChatCounts {
      static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_RELOAD_CHAT_COUNTS;
    }

    export class AddVisibleJobAccordion {
      static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_ADD_VISIBLE_ACCORDION;

      constructor(public accordion: JobAccordions) {
      }
    }

    export class RemoveVisibleJobAccordion {
      static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_REMOVE_VISIBLE_ACCORDION;

      constructor(public accordion: JobAccordions) {
      }
    }

    export class OpenJobAccordion {
      static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_OPEN_ACCORDION;

      constructor(public accordion: JobAccordions) {
      }
    }

    export class CloseJobAccordion {
      static readonly type: ActionEnum = ActionEnum.CHECKLIST_FILL_OUT_CLOSE_ACCORDION;

      constructor(public accordion: JobAccordions) {
      }
    }
  }

}



